import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { FadeVerticalScrollTrigger } from "./FadeVertical/animation";
import { FadeHorizontalScrollTrigger } from "./FadeHorizontal/animation";
import { NoneScrollTrigger } from "./None/animation";
import { ParallaxScrollTrigger } from "./Parallax/animation";
import { SwapHorizontalScrollTrigger } from "./SwapHorizontal/animation";
import type {
  AnimationType,
  Animation,
  BackgroundControllingAnimation,
} from "./types";

export const PinnedSectionDefaults = {
  pin: false,
  pinSpacing: false,
  scrub: 1,
  toggleActions: "restart none reverse reset",
};

export function getAnimation(
  type: AnimationType
): Animation | BackgroundControllingAnimation {
  let animation: Animation | BackgroundControllingAnimation;
  switch (type) {
    case "fade-vertical":
      animation = FadeVerticalScrollTrigger;
      break;
    case "fade-horizontal":
      animation = FadeHorizontalScrollTrigger;
      break;
    case "swap-horizontal":
      animation = SwapHorizontalScrollTrigger;
      break;
    case "parallax":
      // @ts-ignore
      animation = ParallaxScrollTrigger;
      break;
    default:
      animation = NoneScrollTrigger;
  }
  return animation;
}
